<template>
  <div :class="[wrapperClasses]">
    <hr class="application-divider">
  </div>
</template>

<style lang="scss">
  @import "~styles/definitions";

  .application-divider {
    margin: r(32) 0;
    border: none;
    border-top: solid r(2) $black;
  }

  @media print {
    .application-divider {
      display: none !important;
    }
  }
</style>

<script>
  export default {

    props: {
      addWrapper: {
        type: Boolean,
        default: true,
      },
      wrapperClasses: {
        type: String,
        default: 'container container--narrow'
      }
    }
  };
</script>